import { render, staticRenderFns } from "./VCompanyPicker.vue?vue&type=template&id=2b1f5251&scoped=true&"
import script from "./VCompanyPicker.vue?vue&type=script&lang=js&"
export * from "./VCompanyPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1f5251",
  null
  
)

export default component.exports